import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataService } from '../services/data.service';
import { Observable, forkJoin } from 'rxjs';

@Injectable()
export class AssocNazioniResolver implements Resolve<any> {

  constructor(private dataService: DataService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    return forkJoin([this.dataService.getNazioni(), this.dataService.getAssociazioni()]);
  }
}
